export default __webpack_public_path__ + "eaec5a7c2d1d7130dae167e29f619fae.png";